var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-form-wrapper"},[_c('PricingPlan'),_c('CheckoutTabs',{ref:"checkoutTabs"}),(_vm.selectedPricingPlan.renewal_info)?_c('p',{staticClass:"checkout-form-text"},[_vm._v(" "+_vm._s(_vm.$t('checkout.cancel_subscription'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }